
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as indexKS1_ySNavrP_JtRO_UlGA8_U2H_o2fwcsWk24UtGp6oMeta } from "/codebuild/output/src2768984684/src/nuxt/pages/index.vue?macro=true";
import { default as searchi4AxV5vtG4aZk1_O03IOI4XxmlH_95swj32_bV3h6g0Meta } from "/codebuild/output/src2768984684/src/nuxt/pages/search.vue?macro=true";
import { default as signupZ8Nw3sqduXLBZccVKqfXU03z0M4tg6o83mO7GlhD50oMeta } from "/codebuild/output/src2768984684/src/nuxt/pages/signup.vue?macro=true";
import { default as contact9ZjHqGXbhkl_uDp6ayBU9R0BtaKW7kzwBUU_8TcBRgUMeta } from "/codebuild/output/src2768984684/src/nuxt/pages/contact.vue?macro=true";
import { default as cookiesa_OfqHsswvtDGuxqa6CqM94qa18vbg709WsAxud7CyoMeta } from "/codebuild/output/src2768984684/src/nuxt/pages/cookies.vue?macro=true";
import { default as edit1PgPHFGnVl5538sTZ8imeCmDmnhulgk0TGZpmJa5HSwMeta } from "/codebuild/output/src2768984684/src/nuxt/pages/me/edit.vue?macro=true";
import { default as privacy7Hky5HnFOA_9xZRFWfCNE6CXTjLl72HwqtFpGvl9qrgMeta } from "/codebuild/output/src2768984684/src/nuxt/pages/privacy.vue?macro=true";
import { default as indexSpq1Y1E4gBwSlLhZOwR1c3aPNEDLWGRka2c3HaNgHWEMeta } from "/codebuild/output/src2768984684/src/nuxt/pages/me/index.vue?macro=true";
import { default as indexMp4J4OwfGYBqZkmF2lGR3J4Azyq1Yy3N79tJhN_4N5IMeta } from "/codebuild/output/src2768984684/src/nuxt/pages/live/index.vue?macro=true";
import { default as _91passcode_93WgZK3Xpq2LOODnQMqlfLWEMydjGaSS5_TEAI_jxurLMMeta } from "/codebuild/output/src2768984684/src/nuxt/pages/login/index/[passcode].vue?macro=true";
import { default as indexzAnLfghnDp8bVmyFGOdgcaGDixSzi50_GhHVlyGcm9oMeta } from "/codebuild/output/src2768984684/src/nuxt/pages/login/index.vue?macro=true";
import { default as indexutNt2KS0hLC0h1lGkatE4W6djGkNRhSZY_za6ZZK3x4Meta } from "/codebuild/output/src2768984684/src/nuxt/pages/events/index.vue?macro=true";
import { default as indexcRzxlBxP1RBnC5y9eX5pi7kKW7qXNvgEw62g_WPa0zYMeta } from "/codebuild/output/src2768984684/src/nuxt/pages/videos/index.vue?macro=true";
import { default as index1Kd0eE5XKpchvTqzBMnfOk0uQ6YDRh3yzcaUudrnlO0Meta } from "/codebuild/output/src2768984684/src/nuxt/pages/classes/index.vue?macro=true";
import { default as indexyeVD_zReyjtwo2ENONzxhM0_30MNAzx96nov5TkCqlsMeta } from "/codebuild/output/src2768984684/src/nuxt/pages/dancers/index.vue?macro=true";
import { default as _91token_93zvjRn58HKUVJUl1Mi9bmQlYCpZN9Z_XuN1t_cChvoikMeta } from "/codebuild/output/src2768984684/src/nuxt/pages/messages/index/[idThread]/[token].vue?macro=true";
import { default as _91idThread_93RWvM6_LogGOkZIPh9Z41P3Y_C7EVDhoi9wS06tIjHsIMeta } from "/codebuild/output/src2768984684/src/nuxt/pages/messages/index/[idThread].vue?macro=true";
import { default as indexh2qt4vnjuo11TGK_8cs8j8_Q2Y7YXu4Y9VzGyngvBrsMeta } from "/codebuild/output/src2768984684/src/nuxt/pages/messages/index.vue?macro=true";
import { default as indexed_5YCqnb9nES__tYmgjPLH6fA9G9V_RG6H9A9YB9_0Meta } from "/codebuild/output/src2768984684/src/nuxt/pages/login-code/index.vue?macro=true";
import { default as notificationsIAafSlCSxkkNFLi_Ex_Tqk46Yu_GTST2BneB7zYRbQUMeta } from "/codebuild/output/src2768984684/src/nuxt/pages/me/notifications.vue?macro=true";
import { default as _91idVideo_93b97v5FCskljVkqVQGoylxIdNRK1H_mvwA2kPANLxhRoMeta } from "/codebuild/output/src2768984684/src/nuxt/pages/videos/[idVideo].vue?macro=true";
import { default as _91streamSlug_93BY4wxM6NzfPOpMMlmMwzu6Sj9oT8AmyMEp3d_Gr1JqAMeta } from "/codebuild/output/src2768984684/src/nuxt/pages/live/[streamSlug].vue?macro=true";
import { default as _91eventSlug_93zkRD5zI_d_LVUPi13ZtesgdUSRM1LXVWKeLKmN28zGsMeta } from "/codebuild/output/src2768984684/src/nuxt/pages/events/[eventSlug].vue?macro=true";
import { default as _91classSlug_93QjhqaC_CkgtEBNFgaUXhHhkxS67UQHU8ajUwZYap0toMeta } from "/codebuild/output/src2768984684/src/nuxt/pages/classes/[classSlug].vue?macro=true";
import { default as _91dancerSlug_93oWpNKMqkKwaWAq0YCwORGonLTMgQ9_6MWph8aKetyO4Meta } from "/codebuild/output/src2768984684/src/nuxt/pages/dancers/[dancerSlug].vue?macro=true";
import { default as _91token_93jgCtpGe4XOJBMDSyS_2W5qB8n7_6jQSj8NgfkLgrKMcMeta } from "/codebuild/output/src2768984684/src/nuxt/pages/unsubscribe/[email]/[token].vue?macro=true";
import { default as _91token_93rCPMQbq8t2Es8hHM2ogQkOKvroUst8fhQ6HcMm0tXPIMeta } from "/codebuild/output/src2768984684/src/nuxt/pages/unsubscribe-mailers/[email]/[token].vue?macro=true";
export default [
  {
    name: "index",
    path: "/",
    component: () => import("/codebuild/output/src2768984684/src/nuxt/pages/index.vue")
  },
  {
    name: "search",
    path: "/search",
    component: () => import("/codebuild/output/src2768984684/src/nuxt/pages/search.vue")
  },
  {
    name: "signup",
    path: "/signup",
    component: () => import("/codebuild/output/src2768984684/src/nuxt/pages/signup.vue")
  },
  {
    name: "contact",
    path: "/contact",
    component: () => import("/codebuild/output/src2768984684/src/nuxt/pages/contact.vue")
  },
  {
    name: "cookies",
    path: "/cookies",
    component: () => import("/codebuild/output/src2768984684/src/nuxt/pages/cookies.vue")
  },
  {
    name: "me-edit",
    path: "/me/edit",
    meta: edit1PgPHFGnVl5538sTZ8imeCmDmnhulgk0TGZpmJa5HSwMeta || {},
    component: () => import("/codebuild/output/src2768984684/src/nuxt/pages/me/edit.vue")
  },
  {
    name: "privacy",
    path: "/privacy",
    component: () => import("/codebuild/output/src2768984684/src/nuxt/pages/privacy.vue")
  },
  {
    name: "me",
    path: "/me",
    meta: indexSpq1Y1E4gBwSlLhZOwR1c3aPNEDLWGRka2c3HaNgHWEMeta || {},
    component: () => import("/codebuild/output/src2768984684/src/nuxt/pages/me/index.vue")
  },
  {
    name: "live",
    path: "/live",
    component: () => import("/codebuild/output/src2768984684/src/nuxt/pages/live/index.vue")
  },
  {
    name: "login",
    path: "/login",
    component: () => import("/codebuild/output/src2768984684/src/nuxt/pages/login/index.vue"),
    children: [
  {
    name: "login-index-passcode",
    path: ":passcode()",
    component: () => import("/codebuild/output/src2768984684/src/nuxt/pages/login/index/[passcode].vue")
  }
]
  },
  {
    name: "events",
    path: "/events",
    component: () => import("/codebuild/output/src2768984684/src/nuxt/pages/events/index.vue")
  },
  {
    name: "videos",
    path: "/videos",
    component: () => import("/codebuild/output/src2768984684/src/nuxt/pages/videos/index.vue")
  },
  {
    name: "classes",
    path: "/classes",
    component: () => import("/codebuild/output/src2768984684/src/nuxt/pages/classes/index.vue")
  },
  {
    name: "dancers",
    path: "/dancers",
    component: () => import("/codebuild/output/src2768984684/src/nuxt/pages/dancers/index.vue")
  },
  {
    name: "messages",
    path: "/messages",
    component: () => import("/codebuild/output/src2768984684/src/nuxt/pages/messages/index.vue"),
    children: [
  {
    name: "messages-index-idThread",
    path: ":idThread()",
    component: () => import("/codebuild/output/src2768984684/src/nuxt/pages/messages/index/[idThread].vue"),
    children: [
  {
    name: "messages-index-idThread-token",
    path: ":token()",
    component: () => import("/codebuild/output/src2768984684/src/nuxt/pages/messages/index/[idThread]/[token].vue")
  }
]
  }
]
  },
  {
    name: "login-code",
    path: "/login-code",
    component: () => import("/codebuild/output/src2768984684/src/nuxt/pages/login-code/index.vue")
  },
  {
    name: "me-notifications",
    path: "/me/notifications",
    meta: notificationsIAafSlCSxkkNFLi_Ex_Tqk46Yu_GTST2BneB7zYRbQUMeta || {},
    component: () => import("/codebuild/output/src2768984684/src/nuxt/pages/me/notifications.vue")
  },
  {
    name: "videos-idVideo",
    path: "/videos/:idVideo()",
    component: () => import("/codebuild/output/src2768984684/src/nuxt/pages/videos/[idVideo].vue")
  },
  {
    name: "live-streamSlug",
    path: "/live/:streamSlug()",
    component: () => import("/codebuild/output/src2768984684/src/nuxt/pages/live/[streamSlug].vue")
  },
  {
    name: "events-eventSlug",
    path: "/events/:eventSlug()",
    component: () => import("/codebuild/output/src2768984684/src/nuxt/pages/events/[eventSlug].vue")
  },
  {
    name: "classes-classSlug",
    path: "/classes/:classSlug()",
    component: () => import("/codebuild/output/src2768984684/src/nuxt/pages/classes/[classSlug].vue")
  },
  {
    name: "dancers-dancerSlug",
    path: "/dancers/:dancerSlug()",
    component: () => import("/codebuild/output/src2768984684/src/nuxt/pages/dancers/[dancerSlug].vue")
  },
  {
    name: "unsubscribe-email-token",
    path: "/unsubscribe/:email()/:token()",
    component: () => import("/codebuild/output/src2768984684/src/nuxt/pages/unsubscribe/[email]/[token].vue")
  },
  {
    name: "unsubscribe-mailers-email-token",
    path: "/unsubscribe-mailers/:email()/:token()",
    component: () => import("/codebuild/output/src2768984684/src/nuxt/pages/unsubscribe-mailers/[email]/[token].vue")
  }
]